export enum RequestState {
  INITIAL = 'initial',
  PENDING = 'pending',
  RESOLVED = 'resolved',
  REJECTED = 'rejected',
}
